import { useState } from 'react';
import Modal from '../../components/Modal';
import { AdminsApi } from '../../api/resources';
import { errorMessage, validationErrors } from '../../api/client';

/**
 * Create (no `admin` prop) or edit (with `admin`) an admin user.
 */
export default function AdminFormModal({ admin, onClose, onSaved }) {
  const editing = !!admin;
  const [form, setForm] = useState({
    name: admin?.name || '',
    email: admin?.email || '',
    username: admin?.username || '',
    mobile: admin?.mobile || '',
    status: admin?.status || 'active',
    password: '',
    password_confirmation: '',
  });
  const [errors, setErrors] = useState({});
  const [banner, setBanner] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErrors({});
    setBanner('');
    try {
      if (editing) {
        const payload = {
          name: form.name,
          email: form.email,
          username: form.username || null,
          mobile: form.mobile || null,
          status: form.status,
        };
        if (form.password) {
          payload.password = form.password;
          payload.password_confirmation = form.password_confirmation;
        }
        await AdminsApi.update(admin.id, payload);
      } else {
        await AdminsApi.create(form);
      }
      onSaved();
    } catch (err) {
      setErrors(validationErrors(err));
      setBanner(errorMessage(err, 'Could not save.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      title={editing ? `Edit ${admin.name}` : 'New admin'}
      onClose={onClose}
      footer={
        <>
          <button className="btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={submit} disabled={busy}>
            {busy ? 'Saving…' : 'Save'}
          </button>
        </>
      }
    >
      {banner && <div className="notice notice-error">{banner}</div>}
      <form onSubmit={submit}>
        <div className="field">
          <label>Name</label>
          <input type="text" value={form.name} onChange={set('name')} />
          {errors.name && <div className="err">{errors.name}</div>}
        </div>
        <div className="field">
          <label>Email</label>
          <input type="email" value={form.email} onChange={set('email')} />
          {errors.email && <div className="err">{errors.email}</div>}
        </div>
        <div className="field">
          <label>Username (for the Android call app)</label>
          <input type="text" value={form.username} onChange={set('username')} autoComplete="off" />
          {errors.username && <div className="err">{errors.username}</div>}
        </div>
        <div className="field">
          <label>Mobile</label>
          <input type="text" value={form.mobile} onChange={set('mobile')} />
          {errors.mobile && <div className="err">{errors.mobile}</div>}
        </div>
        <div className="field">
          <label>Status</label>
          <select value={form.status} onChange={set('status')}>
            <option value="active">Active</option>
            <option value="inactive">Inactive (cannot sign in)</option>
          </select>
        </div>
        <div className="field">
          <label>{editing ? 'New password (leave blank to keep)' : 'Password'}</label>
          <input type="password" value={form.password} onChange={set('password')} />
          {errors.password && <div className="err">{errors.password}</div>}
        </div>
        <div className="field">
          <label>Confirm password</label>
          <input
            type="password"
            value={form.password_confirmation}
            onChange={set('password_confirmation')}
          />
        </div>
        <button type="submit" hidden />
      </form>
    </Modal>
  );
}
